/**
 * Constants for the custom request flow.
 * Ported from executive app with widget-specific adjustments.
 * @module Widget/CustomRequest/constants
 */

export const FORM_CONSTRAINTS = {
  MIN_GUESTS: 2,
  MAX_GUESTS: 20,
  MAX_TIME_SELECTIONS: 10,
  MIN_EXPIRATION_HOURS: 12,
  DEFAULT_BOOKING_WINDOW_DAYS: 30,
} as const;

export const DEFAULT_TABLE_TYPES = [
  { id: '1', name: 'Indoor' },
  { id: '2', name: 'Outdoor' },
  { id: '3', name: 'Bar Room' },
  { id: '4', name: 'Dining Room' },
];

